module.exports = __webpack_public_path__ + "1d23f7ff6a5366c9cf69430cc42485a6.jpg";